import { mediaData } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 bg-primary-100/80 text-primary-700 text-xs font-semibold rounded-full mb-3">
            精彩周边
          </span>
          <h2 className="text-2xl md:text-4xl font-black text-foreground-950">
            影视周边
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            幕后特辑、深度解析、行业观察——影视不止于正片
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaData.map((item, i) => (
            <div
              key={i}
              className="group bg-background-100 rounded-xl border border-background-200/60 overflow-hidden hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-200">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-background-50 text-xs font-medium rounded">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2 leading-snug">
                  {item.title}
                </h3>
                <div className="mt-2 flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次播放</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}